module.exports = __webpack_public_path__ + "img/collection-weddingRingsNaturalBeige.e4461a2.jpg";